export default "__VITE_ASSET__28329a28__"